export function isElementDuplicated<T>(array: T[], element: T): boolean {
  function countOccurrences(arr: T[], val: T): number {
    return arr.reduce((count, current) => count + (current === val ? 1 : 0), 0);
  }

  const occurrences = countOccurrences(array, element);
  return occurrences > 1;
}
